/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCopyRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M9.5 1.6a2.9 2.9 0 0 0-2.9 2.9v10a2.9 2.9 0 0 0 2.9 2.9h10a2.9 2.9 0 0 0 2.9-2.9v-10a2.9 2.9 0 0 0-2.9-2.9zM8.4 4.5a1.1 1.1 0 0 1 1.1-1.1h10a1.1 1.1 0 0 1 1.1 1.1v10a1.1 1.1 0 0 1-1.1 1.1h-10a1.1 1.1 0 0 1-1.1-1.1z"
        clipRule="evenodd"
      />
      <path d="M3.4 9.5a1.1 1.1 0 0 1 1.1-1.1.9.9 0 0 0 0-1.8 2.9 2.9 0 0 0-2.9 2.9v9a3.9 3.9 0 0 0 3.9 3.9h9a2.9 2.9 0 0 0 2.9-2.9.9.9 0 1 0-1.8 0 1.1 1.1 0 0 1-1.1 1.1h-9a2.1 2.1 0 0 1-2.1-2.1z" />
    </svg>
  );
}
export default IcCopyRegular;
